/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from 'react';
import { ContentBox } from "../ContentBox"
import { SystemPromptInput } from '../../Res/SystemPrompt';
import 'rc-datepicker/lib/style.css';
import { ManagementPrompt } from '../../Res/ManagementPrompt';
import { Pagination } from '../../Res/Pagination';
import { uuid } from '../../../../item/ItemTools';
import { setResume2Token, getUserInfoCompanyId, getval2Token, setVal2Token } from '../../../Login/Auth';
import { ReqDepartmentList } from '../../../../item/ItemDepartment';
import { api_getDepartmentList } from '../../../../api/apiDepartment';
import { SingleLink } from '../../Res/BaseButton';

export function DepartmentList({ setIsLoading, id }) {
    const [tokenId, setTokenId] = useState("")

    const [companyId] = useState(getUserInfoCompanyId())
    const [departmentList, setDepartmentList] = useState([])
    const [page, setPage] = useState(1)
    const [limit] = useState(10)
    const [count, setCount] = useState(0)

    useEffect(() => {
        if (id !== undefined && id !== tokenId) {
          var url = getval2Token("url", id)
          console.log(url)
          setTokenId(id)
          try {
            url = JSON.parse(url)
          } catch (error) {
          }
          toSearch(url)
        }
      }, [id])
    // useEffect(() => {
    //     if (departmentList.length === 0) {
    //         toSearch({ page: 1 })
    //     }
    // }, [])

    // useEffect(()=>{
    //     if(Object.keys(mReqEmployeeResumeList).length !== 0){
    //         toSearch({items: mReqEmployeeResumeList})
    //     }
    // },[mReqEmployeeResumeList])

    function toSearch({ page = 1 }) {
        //console.log("toSearch")
        var start = (page - 1) * limit;
        setPage(page)
        // console.log(id)
        setVal2Token("url", {page}, id)
        var url = getval2Token("url", id)
        // console.log(url)
        var mReqDepartmentList = new ReqDepartmentList({ companyId, start, limit })
        getDepartmentList(mReqDepartmentList)
    }


    async function getDepartmentList(mReqDepartmentList) {
        setIsLoading(true)
        api_getDepartmentList({
            mReqDepartmentList,
            success: (obj) => {
                //console.log(obj)
                setDepartmentList(obj.list)
                setCount(obj.count)
                setIsLoading(false)
            },
            failure: (err) => {
                console.log(err)
                setIsLoading(false)
            }
        })
    }

    function toAdd() {
        window.location.assign("/DepartmentAdd");
    }


    var baseTitle = "部門列表"
    var baseContent =
        <>
            <div className="row m-b-sm">
            </div>
            <ListBox departmentList={departmentList} action={setDepartmentList} count={count} page={page} sp={toSearch} />
        </>

    var title_tools =
        <a className="dropdown-toggle " data-toggle="dropdown" href="#A" onClick={e => toAdd()}>
            <i className="fa fa-pencil text-warning"></i><span className="text-warning m-l-xs">新增</span>
        </a>

    return (
        <>
            <ContentBox title={baseTitle} title_tools={title_tools} content={baseContent} hasDrawer={false} />
            <ManagementPrompt />
            <SystemPromptInput />
        </>
    )
}


function ListBox({ departmentList, action, count, page, sp }) {
    const [mDepartmentList, setDepartmentList] = useState([])
    const [mPage, setPage] = useState(1)
    const [limit] = useState(10)
    const [mCount, setCount] = useState(0)

    const [iStart, setStart] = useState(0)
    const [iEnd, setEnd] = useState(0)

    useEffect(() => {
        if (departmentList !== undefined && mDepartmentList !== departmentList) {
            setStart((page - 1) * limit + 1)
            setEnd((page - 1) * limit + departmentList.length)
            setDepartmentList(setTableList(departmentList))
            setPage(page)
        }

    }, [departmentList])

    useEffect(() => {
        if (count !== mCount) {
            setCount(count)
        }
    }, [count])

    function setTableList(departmentList) {
        var list = []
        for (var i = 0; i < limit; i++) {
            if (departmentList[i] !== undefined) {
                list.push(<DepartmentBox key={departmentList[i].departmentId} department={departmentList[i]} />)
            } else {
                list.push(<DepartmentBox key={"resumeId" + i} />)
            }
        }
        return list
    }

    function sPage(p) {
        console.log("pagechange" + p)
        if (p !== page) {
            sp({ page: p })
            setPage(p)
        }
    }

    if (mDepartmentList.length === 0) {
        return (<></>)
    } else {
        //console.log(managerList)
        return (
            <div id="editable_wrapper" className="form-inline dt-bootstrap">
                <div className="row">
                    <div className="col-sm-12">
                        <table className="table table-striped table-bordered table-hover  dataTable">
                            <thead>
                                <tr role="row">
                                    <th className="text-center sorting col-sm-4">名稱</th>
                                    <th className="text-center sorting col-sm-4">上級單位</th>
                                    <th className="text-center sorting col-sm-2">職務數</th>
                                    <th className="text-center sorting col-sm-2">狀態</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    mDepartmentList.map((department) => (
                                        department
                                    ))
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
                {
                    mCount === 0 ? <></> : <Pagination p={mPage} l={limit} c={mCount} sp={sPage} s={iStart} e={iEnd} />
                }
            </div>
        )
    }

}

function DepartmentBox({ department }) {
    const [mDepartment, setDepartment] = useState({})
    const [departmentName, setDepartmentName] = useState("")
    const [managerDepartmentName, setManagerDepartmentName] = useState("")
    const [count, setCount] = useState("")
    const [isDisable, setIsDisable] = useState("")
    const [mTokenId, setTokenId] = useState("")

    useEffect(() => {
        if (department !== undefined && department !== mDepartment) {
            //console.log(department)
            setDepartment(department)
            var tokenId = uuid(128, 64)
            setTokenId(tokenId)
            setDepartmentName(department.departmentName)
            setManagerDepartmentName(department.managerDepartmentName)
            setCount(department.count)
            setIsDisable(department.isDisable)
        }
    }, [department])

    return (
        <tr role="row">
            <td className="text-center"><SingleLink link={"DepartmentDetail"} name={departmentName} Key={"departmentId"} val={mDepartment.departmentId}></SingleLink>&nbsp;</td>
            <td className="text-center">{managerDepartmentName}</td>
            <td className="text-center">{count}</td>
            <td className="text-center">
                {isDisable === "" ? <></> : isDisable===0 ? <span className="text-info">啟用</span> : <span className="text-danger">停用</span>}
            </td>
        </tr>
    )
}
